import { CloseCircleFilled, CheckCircleFilled, FileExcelOutlined } from "@ant-design/icons";
import { Button, Table, Tooltip, Typography, Form, Select } from "antd";
import moment from "moment";
import { apiDownload } from "../../utils/Api";
import { apiCall } from "../../utils/Api";
import { useState, useEffect } from "react";



export default function RsvpCard(props){

    const { id } = props;

    const [ results, setResults ] = useState();
    const [ loading, setLoading ] = useState(true);

    const getRsvp = (_id) => {
        setLoading(true);
        apiCall("events/v2/get", { id: _id }, (_status, _result) => {
            if (_status) {
                // find first upcoming date
                const date = Date.now();
                const firstUpcoming = _result.recurrence_dates
                    .map(d => new Date(d).getTime())
                    .filter(ts => ts >= date)
                    .sort((a, b) => a - b)[0];

                const firstUpcomingStr = firstUpcoming
                    ? _result.recurrence_dates.find(d => new Date(d).getTime() === firstUpcoming)
                    : null;

                setResults({ rows: [_result], row_count: 1 });
                setRd(_result.rsvp_per_day);
                setOc(firstUpcomingStr || moment(_result.date).format("YYYY-MM-DD"));
                setLoading(false);
            }
        });
    };

    const [ rd, setRd ] = useState();
    const [oc, setOc] = useState();

    useEffect(() => {
        getRsvp(id);
    }, [id]);

    const columnsRSVP = [
        {
            title: "", ellipsis: true, width: 20, dataIndex: "cancelled", key: "cancelled", render: (e) => {
                return ((e) ? <CloseCircleFilled style={{ color: "#9e9e9e" }} /> : <CheckCircleFilled style={{ color: "#59bf51" }} />)
            }
        },
        { title: "Name", ellipsis: true, dataIndex: "name", key: "name" },
        {
            title: "Email", ellipsis: true, dataIndex: "email", key: "email", render: (e) => {
                const mailto = "mailto:" + e;
                return (<a href={mailto}>{e}</a>)
            }
        },
        { title: "Phone", width: "100px", ellipsis: true, dataIndex: "phone", key: "phone" },
        { title: "Qty", width: "50px", dataIndex: "quantity", key: "quantity", render: (e) => { return (<Tooltip title="Number of attendees">{e}</Tooltip>)}},
    ];

    const downloadExcel = () => {

        let obj = {}
        obj.event_id = results.rows[0]?.id;

        if (rd) {
            obj.recurrence_date = oc;
        }
        apiDownload(obj, "events/v2/listRsvpExcel", true);
    }

    const filterRSVP = (_waitlist = false) => {
        if (rd) {
            return results.rows[0]?.rsvp?.filter(item => item.on_waitlist === _waitlist && item.recurrence_date === oc) || [];

        } else {
            return results.rows[0]?.rsvp?.filter(item => item.on_waitlist === _waitlist) || [];
        }
    }
    
    return (
        <>
            {loading ? (
                <div style={{ padding: "20px" }}>Loading...</div>
            ) : results ? (
                <div style={{ padding: "20px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "0 30px 10px 0" }}>
                        <Typography.Title level={5}>RSVP List</Typography.Title>
                    <Form.Item style={{ "marginBottom": "0" }}>
                        <Select
                            value={oc}
                            onChange={(value) => setOc(value)}
                            disabled={!rd}
                            style={{ width: 150 }}
                        >
                            {results.rows[0]?.recurrence_dates?.map(item => (
                                <Select.Option key={item} value={item}>
                                    {moment(item).format("MMM Do, YYYY")}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                        <Button onClick={() => downloadExcel()} type="primary" size="small">
                            <small><FileExcelOutlined />&nbsp;Export XLS</small>
                        </Button>
                    </div>
                    <Table
                        size="small"
                        pagination={false}
                        rowKey="id"
                        className={"tableNoBorder"}
                        columns={columnsRSVP}
                        dataSource={filterRSVP(false)}
                    />
                </div>
            ) : (
                <div style={{ padding: "20px" }}>No data available</div>
            )}
        </>
    );
}
